import 'react-vertical-timeline-component/style.min.css';

import { Calendar, Form } from '@alifd/next';
import { StarFilled } from '@ant-design/icons';
import { Box } from '@mui/material';
import { Image, Modal } from 'antd'; // dialog UI
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const { Item } = Form;
const currentDate = moment();
const localeData = currentDate.clone().localeData();
const monthLocale = localeData.monthsShort();

const CalendarFrontDesk = () => {
  // calendar 行事曆Table
  const calendar = client.service('calendar');
  const [calendarArr, setCalendarArr] = useState([]);

  const [dialogDataArr, setDialogDataArr] = useState([]);
  const [dialogDataObj, setDialogDataObj] = useState({});
  const [viewDialog, setViewDialog] = useState(false);
  const [viewDialog2, setViewDialog2] = useState(false);
  const [nowDate, setNowDate] = useState(moment());
  const [showImage, setShowImage] = useState(false);
  const user = useSelector((state) => state.user);

  const funFind = useCallback(
    async (para) => {
      const result = await calendar.find({ query: para });
      return result && result.data ? result.data : [];
    },
    [calendar]
  );

  const serverDataUpdate = useCallback(() => {
    funFind({}).then((result) => {
      console.log('calendar---Data----::', result);
      setCalendarArr(result);
      setDialogDataArr(
        result.filter((i) => {
          return moment(i.selectTime).isBetween(
            moment().startOf('day'),
            moment().endOf('day'),
            undefined,
            '[]'
          );
        })
      );
    });
  }, [funFind]);

  useEffect(() => {
    serverDataUpdate();
  }, [serverDataUpdate]);

  function monthCellRender2(date) {
    // render年
    const thisStartDate = new Date(
      `${date.year()}/${date.month() + 1}/1`
    ).getTime(); // 月初time
    const thisEndDate = new Date(date.year(), date.month() + 1, 0).getTime(); // 月底time
    const renderArr = [];
    const idArrs = [];

    const eventList = [...calendarArr].filter(
      (i) => i.selectTime >= thisStartDate && i.selectTime <= thisEndDate
    ); // 找到當月所有任務(有重複)
    eventList.forEach((e) => {
      // 過濾掉相同id任務(只show一次)
      if (!idArrs.includes(e._id)) {
        idArrs.push(e._id);
        renderArr.push(e);
      }
    });
    // const formatStr = renderArr.map((i, nb) => {
    //   return <div key={nb}>{i.title}</div>;
    // });

    return (
      <>
        <div className={styles.calendarMonthText}>
          {monthLocale[date.month()]}
        </div>
        <div className={styles.calendarYearBox}>
          <div style={{ textAlign: 'center' }}>
            {eventList.length > 0 ? (
              <StarFilled
                style={{
                  color: 'rgb(249, 195, 32)',
                  marginTop: '10px',
                  fontSize: '2vw',
                }}
              />
            ) : (
              <StarFilled
                style={{
                  color: 'transparent',
                  marginTop: '10px',
                  fontSize: '2vw',
                }}
              />
            )}
          </div>
        </div>
      </>
    );
  }

  function dateCellRender2(date) {
    // 渲染測試
    const dateNum = date.date();
    const thisCalendarDate = new Date(
      `${date.year()}/${date.month() + 1}/${dateNum}`
    ).getTime(); // 當日time
    const eventList = [...calendarArr].filter(
      (i) =>
        moment(i.selectTime)
          .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .valueOf() === thisCalendarDate
    );

    return (
      <>
        <div className={styles.calendarMonthBox}>
          <div className={styles.calendarMonthText}>{dateNum}</div>
          <div>
            <div style={{ textAlign: 'center' }}>
              {eventList.length > 0 ? (
                <StarFilled
                  style={{
                    color: 'rgb(249, 195, 32)',
                    marginTop: '10px',
                    fontSize: '2vw',
                  }}
                />
              ) : (
                <StarFilled
                  style={{
                    color: 'transparent',
                    marginTop: '10px',
                    fontSize: '2vw',
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
  const showCalenderData = (day, value) => {
    let diaArr = [];
    diaArr = [...calendarArr].filter((i) => {
      return moment(i.selectTime).isBetween(
        moment(day).startOf(value),
        moment(day).endOf(value),
        undefined,
        '[]'
      );
    });
    setDialogDataArr(diaArr);
  };

  const isFilesExist = dialogDataObj?.files && dialogDataObj?.files.length > 0;

  return (
    <Box
      sx={{
        width: '100vw',
        height: 'calc(100vh - var(--header-height))',
        position: 'fixed',
        top: 'var(--header-height)',
        overflowY: 'auto',
      }}
    >
      {/* 當天活動 */}
      <Modal
        closable={false}
        mask={false}
        className={styles.dialog}
        open={viewDialog}
        okText
        onOk={() => {
          setViewDialog(false);
        }}
        onCancel={() => {
          setViewDialog(false);
        }}
        cancelText="關閉"
      >
        {dialogDataArr.length > 0 ? (
          dialogDataArr.map((item, index) => {
            return (
              <div
                key={index}
                className={styles.dialogArr}
                onClick={() => {
                  console.log('cc AT::', item._id);
                  setDialogDataObj(item);
                  setViewDialog2(true);
                }}
              >
                <p className={styles.icons}>
                  {moment(item.selectTime).format('HH:mm')}
                </p>
                <p className={styles.title}>{item.title}</p>
                <p className={styles.content}>{item.content}</p>
                {/* <textarea name="content" className={styles.content} rows="2">{item.content}</textarea> */}
                <hr className={styles.bcolor} />
              </div>
            );
          })
        ) : (
          <div className={styles.dialogArr}>
            <p className={styles.title}>沒有活動</p>
          </div>
        )}
      </Modal>

      {/* 詳細活動 */}
      <Modal
        closable={false}
        mask={false}
        className={`${styles.dialog} ${styles.pp2}`}
        open={viewDialog2}
        okText
        onOk={() => {
          setDialogDataObj({});
          setViewDialog2(false);
        }}
        onCancel={() => {
          setDialogDataObj({});
          setViewDialog2(false);
        }}
        cancelText="關閉"
      >
        {/* {Object.prototype.hasOwnProperty.call(dialogDataObj, 'selectTime') &&
        Object.prototype.hasOwnProperty.call(dialogDataObj, 'title') &&
        Object.prototype.hasOwnProperty.call(dialogDataObj, 'files') ? ( */}
        <Form>
          <Item label="標題">
            <span className={styles.title}>{dialogDataObj?.title}</span>
            <span className={styles.fixTime}>
              {moment(dialogDataObj?.selectTime).format('YYYY-MM-DD HH:mm')}
            </span>
          </Item>
          {dialogDataObj?.content && (
            <Item label="內容">
              <span className={styles.content}>{dialogDataObj?.content}</span>
            </Item>
          )}

          {dialogDataObj?.fileType === 'img' && isFilesExist && (
            <Item label="檔案">
              <Image
                preview={{ visible: false }}
                className={styles.previewImg}
                src={dialogDataObj.files[0].response.showPath}
                onClick={() => setShowImage(true)}
              />
              <div style={{ display: 'none' }}>
                <Image.PreviewGroup
                  preview={{
                    visible: showImage,
                    onVisibleChange: (vis) => setShowImage(vis),
                  }}
                >
                  {dialogDataObj.files.map((file, index) => (
                    <Image src={file.response.showPath} key={index} />
                  ))}
                </Image.PreviewGroup>
              </div>
              {/* <img
                src={dialogDataObj.files[0].response.showPath}
                className={styles.previewImg}
                onClick={() => {
                  setShowImage(true);
                }}
              />
              {showImage && (
                <ImageViewer
                  src={dialogDataObj.files.map(
                    (item) => item.response.showPath
                  )}
                  currentIndex={0}
                  onClose={() => setShowImage(false)}
                  backgroundStyle={{
                    backgroundColor: 'rgba(0,0,0,0.9)',
                  }}
                />
              )} */}
            </Item>
          )}
          {dialogDataObj?.fileType === 'file' && isFilesExist && (
            <Item label="檔案">
              {dialogDataObj.files.map((list) => (
                <>
                  <Image
                    preview={{ visible: false }}
                    className={styles.previewImg}
                    src={list.response.png[0]}
                    onClick={() => setShowImage(true)}
                  />
                  <div style={{ display: 'none' }}>
                    <Image.PreviewGroup
                      preview={{
                        visible: showImage,
                        onVisibleChange: (vis) => setShowImage(vis),
                      }}
                    >
                      {list.response.png.map((file, index) => (
                        <Image src={file} key={index} />
                      ))}
                    </Image.PreviewGroup>
                  </div>
                  {!user.auth.user?.keyboardAccount && (
                    <a
                      className={styles.downloadBtn}
                      download={list.response.oldName}
                      target="_blank"
                      rel="noreferrer"
                      href={list.response.showPath}
                    >
                      {list.name}下載
                    </a>
                  )}
                </>
              ))}
            </Item>
          )}
          {!isFilesExist && <Item label="檔案">無</Item>}
        </Form>
        {/* ) : null} */}
      </Modal>

      <div className={styles.mobileCalendar}>
        <div className={styles.mobileCalendarBackground} />
        {/* 日曆ＵＩ */}
        <Calendar
          // mode
          className={styles.calender}
          onSelect={(value) => {
            setNowDate(value);
            showCalenderData(value, 'day');
          }}
          onVisibleMonthChange={(value) => {
            setNowDate(value);
            showCalenderData(value, 'month');
          }}
          onModeChange={() => {
            showCalenderData(moment(nowDate), 'month');
          }}
          dateCellRender={dateCellRender2}
          monthCellRender={monthCellRender2}
          yearRange={[2021, new Date().getFullYear() + 1]}
        />

        {/* 前10列表 */}
        <div className={styles.itemBottom}>
          {dialogDataArr
            .sort(function (a, b) {
              // 最新 ~ 最遙遠
              return a.selectTime - b.selectTime;
            })
            .slice(0, 10)
            .map((item, index) => {
              return (
                <div
                  key={index}
                  className={styles.rowItems}
                  onClick={() => {
                    setDialogDataObj(item);
                    setViewDialog(false);
                    setViewDialog2(true);
                  }}
                >
                  <p className={styles.title}>
                    <span className={styles.icons}>
                      {moment(item.selectTime).format('YYYY年MM月DD日')}
                    </span>
                    <span>{item.title}</span>
                  </p>
                  <p className={styles.content}>{item.content}</p>
                  <hr className={styles.bcolor} />
                </div>
              );
            })}
        </div>
      </div>
    </Box>
  );
};

export default CalendarFrontDesk;
